import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The valuation of ecosystem services of wetland ecosystems,
              district-wise for Karnataka State, India is implemented as per the
              validated protocol - System of Environmental Economic Accounting
              (SEEA, 2021). Services of the ecosystem were quantified by
              considering only the contribution of the ecosystem to the benefit,
              through the residual value method by taking the gross value of the
              final marketed good to which the ecosystem service provides input
              and then deducting the cost of all other inputs, including labour,
              produced assets, and intermediate inputs.&nbsp;
            </p>
            <p>
              The value of wetland ecosystem services, helps in developing
              appropriate policies toward the conservation and sustainable
              management of ecosystems. The value of provisioning, regulating,
              and cultural services ranged from 4 - 821.4 ten million Rs/yr,
              15.7 - 3264.1 ten million Rs/yr, and 3 - 628.7 ten million Rs/yr
              respectively. Among the districts, the Tumakuru district
              contributes significantly with TESV of 47.14 billion Rs/yr. TESV
              of Karnataka wetlands amounts to 285 billion Rs/yr and the NPV is
              7321 billion rupees. The valuation of ecosystem services
              underlines the fact that wetlands are highly productive and
              economically viable ecosystems, and the accounting of ecosystem
              services provides crucial information for optimal decision making
              toward the wise use of wetland resources.
            </p>
            <p>
              Conservation of wetland ecosystems entails regular monitoring of
              water quality, recording of aquatic species, regular removal of
              accumulated silt, maintaining riparian vegetation, prevention of
              untreated wastewater inflow, regulating the introduction of exotic
              species, implementation of constructed wetlands and algal pond at
              inlets for nutrient removal, awareness among stakeholders,
              including public through regular seminars, workshops, and media,
              encouraging research on wetlands, adoption of wetlands by the
              local educational institutions for regular monitoring and
              environmental education programmes, and constituting a functional
              working committee of subject experts, local people, and decision
              makers for regular auditing and to provide valuable inputs to the
              wetland custodians.
            </p>
            <p>
              <strong>Acknowledgement</strong>
            </p>
            <p>
              We thank the ENVIS Division, The Ministry of Environment, Forests
              and Climate Change, Government of India and Indian Institute of
              Science (IISc) for the sustained support to ecological research.
            </p>
            <p>
              <br />
              <br />
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
